import { render, staticRenderFns } from "./AddStudentTemplate.vue?vue&type=template&id=0c03d018&scoped=true&"
import script from "./AddStudentTemplate.vue?vue&type=script&lang=js&"
export * from "./AddStudentTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddStudentTemplate.vue?vue&type=style&index=0&id=0c03d018&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c03d018",
  null
  
)

export default component.exports